module.exports = __webpack_public_path__ + "static/media/Drawer-plus.b75282dc.svg";